import Navbar from "../components/navbar";


const Contact = () => {
    return (
        <div className="layout">
            <Navbar />
            <div className="contactBox">
                <p>Shanti Bhavan</p>
                <p>Uzan Bazar</p>
                <p>Guwahati, Assam</p>
                <br />
                <p>contact@kwhour.in</p>

            </div>
        </div>
    )
}

export default Contact;